module.exports = __webpack_public_path__ + "static/transporter011-94c31e70a8be0ddfc6ba7e124854252d.png";